export default "__VITE_ASSET__5933296e__"